import { Appearance, StripeElementsOptions } from '@stripe/stripe-js';
import { useGetIsMobile } from 'hooks/useGetIsMobile';
import { useMonetizationLightMode } from 'providers/MonetizationLightModeProvider/MonetizationLightModeContext';
import { useTheme } from 'styled-components';
import { appDefaultColors } from 'styles/themes/appDefaultColors';

const useStripeProviderOptions = (isFormActive: boolean) => {
  const { colors } = useTheme();
  const { forceLightMode } = useMonetizationLightMode();
  const { isMobile } = useGetIsMobile();

  const colorsForStripe = forceLightMode
    ? {
        ...colors,
        neutrals: appDefaultColors.default.neutrals,
        system: appDefaultColors.default.system,
        shadow: appDefaultColors.default.shadow,
      }
    : colors;

  const appearance: Appearance = {
    variables: {
      borderRadius: '8px',
      spacingGridColumn: '16px',
      spacingGridRow: '16px',
      colorDanger: colorsForStripe.system.red,
      colorText: isFormActive ? colorsForStripe.neutrals[1] : colorsForStripe.neutrals[6],
      colorTextPlaceholder: isFormActive ? colorsForStripe.neutrals[4] : colorsForStripe.neutrals[6],
      colorPrimary: colorsForStripe.primary[1],
      colorIconTab: colorsForStripe.neutrals[3],
      colorTextSecondary: colorsForStripe.neutrals[3],
      focusOutline: 'none',
      fontFamily: 'Manrope, system-ui, sans-serif',
      fontSizeBase: '14px',
      fontLineHeight: '20px',
      focusBoxShadow: `0 0 0 1px ${isFormActive ? colorsForStripe.primary[1] : colorsForStripe.neutrals[10]}`,
      colorBackground: colorsForStripe.neutrals[10],
    },
    rules: {
      '.Input--invalid': {
        boxShadow: `0 0 0 1px ${colorsForStripe.system.red}`,
        backgroundColor: colorsForStripe.system.lightRed,
        color: colorsForStripe.neutrals[1],
      },
      '.Input': {
        boxShadow: `0 0 0 1px ${isFormActive ? colorsForStripe.neutrals[8] : colorsForStripe.neutrals[10]}`,
      },
      '.Input:focus': {
        fontSize: isMobile ? '16px' : '14px',
      },
      '.Label': {
        color: colorsForStripe.neutrals[4],
        marginLeft: '12px',
        fontWeight: '400px',
        fontSize: '12px',
        lineHeight: '16px',
      },
      '.Error': {
        fontWeight: '400px',
        fontSize: '12px',
        lineHeight: '16px',
      },
    },
    theme: 'flat',
  };

  const options: StripeElementsOptions = {
    fonts: [
      {
        cssSrc: 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700&display=swap',
      },
    ],
    locale: 'en',
    appearance,
  };

  return { options };
};

export default useStripeProviderOptions;
